import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalculator,
  faFlask,
  faIndianRupeeSign,
  faBolt,
  faBrain,
  faChevronRight
} from "@fortawesome/free-solid-svg-icons";

const calcs = [
  { name: "Basic Super Calculator", path: "/basiccalc", icon: faCalculator },
  { name: "Scientific Calculator", path: "/scientificcalc", icon: faFlask },
  { name: "Financial Calculator", path: "/financialcalc", icon: faIndianRupeeSign },
  { name: "Life-Hack Calculators", path: "/lifehackcalc", icon: faBolt },
  { name: "Software IP Valuation", path: "/softwareipvalcalc", icon: faBrain }
];

function CalcGeniusHome() {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">Think5Whys CalcGenius</div>
          <div className="text-xs lg:text-sm text-gray-100">More Than Calculators!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[80vh] mt-2">
        <div className="mt-4 px-2">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {calcs.map((calc, index) => (
              <Link
                key={index}
                to={calc.path}
                className={`flex items-center gap-3 p-3 rounded-xl border 
                  bg-black text-white 
                  transition-all duration-200
                  hover:scale-[1.02] hover:border-white hover:shadow-md
                  ${calc.highlight ? "border-yellow-400" : "border-gray-700"}
                `}
              >
                <div
                  className={`p-2 rounded-lg 
                    ${calc.highlight ? "bg-yellow-500 text-black" : "bg-gray-800"}
                  `}
                >
                  <FontAwesomeIcon icon={calc.icon} />
                </div>

                <div className="text-sm lg:text-base font-medium text-white">
                  {calc.name}
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default CalcGeniusHome;
